<template>
  <div class="search-btn" @click="change()">搜索</div>
</template>

<script>
export default {
  name: 'search-form-item-button',
  methods:{
    change(){
      this.$emit('on-click');
    }
  }
}
</script>

<style lang="less" scoped>
.search-btn {
  margin-right: 10px;
  margin-left: 0px;
  display: inline-block;
  color: #111111;
  border: 1px solid #c4c6cf;
  border-radius: 500px;
  padding: 0 15px;
  font-size: 14px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
  user-select: none;
}
</style>
